import axios from 'axios'
import globalConfig from '../config/globle.config'
//创造一个axios的实例
const service = axios.create({
  baseURL: globalConfig.thirdRootUrl,
  timeout: 60 * 3 * 1000,
})

service.interceptors.request.use((config) => {
  return config
})

service.interceptors.response.use((res) => {
  var contentType = res.headers['content-type'];
  if (contentType && !contentType.includes("json")) {
    //文件类型的响应，非JSON Api 响应
    return Promise.resolve(res)
  }
  if (contentType && contentType.includes("json") && res.data && res.data.code != 0) {
    switch (res.data.code) {
      case 401:
        if (e.config.redirectLogin) {
          store.push('login')
        }
        return Promise.reject(res.data)
      case -1:
        notification.error({
          message: '错误',
          description: '异常:' + res.data.msg,
        })
        return Promise.reject(res.data)
    }
  }
  return Promise.resolve(res.data)
}, {})

export default service
